'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = expandAliases;

var _enhancers = require('./enhancers');
/**
 * Expands aliases like `margin` to `marginTop`, `marginBottom`, `marginLeft` and `marginRight`.
 *
 * This prevents edge cases where longhand properties can't override shorthand
 * properties due to the style insertion order.
 */


function expandAliases(props) {
  var propNames = Object.keys(props); // Use a Map because it's faster for setting values and looping over than an Object

  var newProps = new Map();

  for (var i = 0; i < propNames.length; i++) {
    var propName = propNames[i];
    var propValue = props[propName];
    var aliases = _enhancers.propAliases[propName] || [propName]; // Check that the alias has a valid value in development

    if (process.env.NODE_ENV !== 'production') {
      var validator = _enhancers.propValidators[propName];

      if (validator) {
        var result = validator(propValue);

        if (result) {
          throw new Error("\uD83D\uDCE6 ui-box: " + result);
        }
      }
    } // Expand aliases


    for (var _i = 0; _i < aliases.length; _i++) {
      newProps.set(aliases[_i], propValue);
    }
  }

  return newProps;
}